import script from "./ShippingAddressExport.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShippingAddressExport.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__